import React from 'react';
import { StarIcon } from '@heroicons/react/24/solid';

const StarRating = ({ rating = 0, max = 5 }) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating - fullStars >= 0.5;
  const emptyStars = max - fullStars - (halfStar ? 1 : 0);

  return (
    <div className="flex items-center space-x-0.5">
      {[...Array(fullStars)].map((_, i) => (
        <StarIcon key={`full-${i}`} className="w-4 h-4 text-yellow-400" />
      ))}
      {halfStar && (
        <StarIcon
          className="w-4 h-4 text-yellow-400"
          style={{ clipPath: 'inset(0 50% 0 0)' }}
        />
      )}
      {[...Array(emptyStars)].map((_, i) => (
        <StarIcon key={`empty-${i}`} className="w-4 h-4 text-gray-300" />
      ))}
    </div>
  );
};

export default StarRating;
